// React import
import React from 'react';
import { connect } from "react-redux";
// Components import
import WalletTokensStatsItem from "../WalletTokensStatsItem";
// Styles imports
import './WalletTokensStats.css';
import '../../util.css'

class WalletTokensStats extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { walletTokens } = this.props.checkWallet;
        const { ai_level, subscription } = this.props.userData;

        return(
            <div className={"check-wallet__tokens-stats-block noselect"}>
                {walletTokens.map((walletToken, index) =>
                    <WalletTokensStatsItem
                        key={index}
                        address={walletToken.address}
                        index={index}
                        symbol={walletToken.symbol}
                        name={walletToken.name}
                        indicator={walletToken.indicator}
                        bought={walletToken.bought}
                        sold={walletToken.sold}
                        profit={walletToken.profit}
                        pnl={walletToken.pnl}
                        firstTx={walletToken.firstTx}
                        tradeTime={walletToken.tradeTime}
                        buys={walletToken.buys}
                        sells={walletToken.sells}
                        aiLevel={ai_level}
                        subscription={subscription}
                    />
                )}
            </div>
        );
    }

}

const mapStateToProps = ({ checkWallet, userData }) => {
    return { checkWallet, userData };
};

export default connect(mapStateToProps)(WalletTokensStats);